// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"d6317d70","498":"bcb3130b"}[chunkId] + ".chunk.css";
};